import React, { Suspense, useEffect } from "react";
import { Switch, Redirect, Route, useHistory } from "react-router-dom";
import { getToken, getUserInfo, getRefreshToken } from "@/utils/auths.js";
import { getAllAuthList, getConfigList, handelAuthPage } from "@/utils/Integration.js";
const RouterView = (props) => {
	const history = useHistory();
	let { route } = props;
	// 加载时的dom
	const routeConfig = getConfigList();
	const arrPath = [];
	const deleteArr = ["/login", "/404", "/layout", "/layout/goods", "/layout/system", "/layout/review", "/cookies", "/protection", "/protectionSalon", "/termsUsage", "/copyrightNotice"];
	const authArr = [];
	routeConfig.forEach((item) => {
		arrPath.push(item.path);
		if (deleteArr.indexOf(item.path) < 0) {
			authArr.push(item);
		}
	});
	const handelAuthArrMore = (item) => {
		const authChargeArr = [];
		if (item.authority.length > 0) {
			item.authority.forEach((item) => {
				if (item) {
					if (getAllAuthList(item)) {
						authChargeArr.push("trues");
					}
				}
			});
		}
		if (authChargeArr.length === 0) {
			history.push("/404");
		}
	}

	const handelAuthArr = (pathLocation) => {
		if (authArr.length > 0) {
			authArr.forEach((item) => {
				if (item.path === pathLocation) {
					handelAuthArrMore(item)
				}
			});
		}
	}
	const initHandel = () => {
		const arrs = ["/login", "/404", "/cookies", "/protection", "/protectionSalon", "/termsUsage", "/copyrightNotice"];
		const pathLocation = history.location.pathname;
		if (arrPath.indexOf(pathLocation) < 0) {
			history.push("/404");
		} else if (arrs.indexOf(pathLocation) < 0) {
			if (!(getToken() && getRefreshToken())) {
				history.push("/login");
			}
			handelAuthPage(history);
			handelAuthArr(pathLocation)
		}
		if (!(getToken() && getUserInfo) && arrs.indexOf(pathLocation) < 0) {
			history.replace("/login");
		}
	}

	useEffect(() => {
		initHandel()
	}, [history.location.pathname]);
	return (
		<Suspense>
			<Switch>
				<Redirect from="/" to={`${getToken() && getUserInfo() ? "/layout" : "login"}`} exact />
				<Redirect from="/layout/review/retail" to="/layout/review/retail/unaudited" exact />
				<Redirect from="/layout/review/professional" to="/layout/review/professional/unaudited" exact />
				{route.map((item, index) => {
					return item.component ? (
						<Route
							key={item.path}
							path={item.path}
							render={(props) => {
								return <item.component route={item.routes} {...props} />;
							}}
						/>
					) : (
						<Redirect key={item.path} from={item.path} to={item.redirect} />
					);
				})}
			</Switch>
		</Suspense>
	);
};

export default RouterView;
